/**
 * Interface with the server
 */
import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';

const groupMembershipsAPI = API('/api/groupMemberships.v2', { type: 'rest' });

const GroupMembershipAPIUtils = {
  getMembers(groupId: $TSFixMe, start: $TSFixMe, limit: $TSFixMe) {
    const uri = new URI()
      .addQueryParam('q', 'members')
      .addQueryParam('groupId', groupId)
      .addQueryParam('includes', 'userPublicProfiles')
      .addQueryParam('fields', 'userPublicProfiles.v1(externalUserId),isViewAsLearnerMembership')
      .addQueryParam('limit', limit);

    return Q(groupMembershipsAPI.get(uri.toString()));
  },

  getMembershipForCurrentUser(groupId: $TSFixMe) {
    const uri = new URI().addQueryParam('q', 'currentUser').addQueryParam('groupId', groupId);

    return Q(groupMembershipsAPI.get(uri.toString()));
  },

  deleteMember(groupId: $TSFixMe, memberId: $TSFixMe) {
    return Q(groupMembershipsAPI.delete(`${memberId}~${groupId}`));
  },

  deleteMembers(groupId: $TSFixMe, members: $TSFixMe) {
    const uri = new URI().addQueryParam('action', 'deleteMemberships').addQueryParam('groupId', groupId);
    return Q(groupMembershipsAPI.post(uri.toString(), { data: members }));
  },

  searchMembers(groupId: $TSFixMe, text: $TSFixMe) {
    const uri = new URI().addQueryParam('q', 'search').addQueryParam('groupId', groupId).addQueryParam('text', text);

    return Q(groupMembershipsAPI.get(uri.toString()));
  },

  myCourseGroupsWithSettings(userId: $TSFixMe, courseId: $TSFixMe) {
    const uri = new URI()
      .addQueryParam('q', 'userAndCourse')
      .addQueryParam('userId', userId)
      .addQueryParam('courseId', courseId)
      .addQueryParam('includes', 'groups,groupSettings');

    return Q(groupMembershipsAPI.get(uri.toString()));
  },

  getCourseSessionGroup(userId: $TSFixMe, courseId: $TSFixMe, sessionId: $TSFixMe) {
    if (!userId || !courseId || !sessionId) {
      return Q();
    }

    const uri = new URI()
      .addQueryParam('q', 'userAndSession')
      .addQueryParam('userId', userId)
      .addQueryParam('courseId', courseId)
      .addQueryParam('sessionId', sessionId);

    return Q(groupMembershipsAPI.get(uri.toString()));
  },
};

export default GroupMembershipAPIUtils;

export const {
  getMembers,
  getMembershipForCurrentUser,
  deleteMember,
  deleteMembers,
  searchMembers,
  myCourseGroupsWithSettings,
  getCourseSessionGroup,
} = GroupMembershipAPIUtils;
